export { CobrandCardHorizontalFlexible } from './CobrandCardHorizontalFlexible';
